import { AppSettings } from '@access-erp/common';

export const appSettings = {
  REST_URL: process.env.REST_ENDPOINT_EXPORTS,
  INSTRUMENTATION_KEY: process.env.APPINSIGHTS_INSTRUMENTATION_KEY,
  WORKSPACE_GRAPHQL_URL: process.env.WORKSPACE_GRAPHQL_URL ?? '',
  REPORT_STORE_API_URL: process.env.REPORT_STORE_API_URL ?? '',
  AppInsightsConfig: {
    disableCookiesUsage: true,
  },
} as unknown as AppSettings;
